export default __webpack_public_path__ + "static/media/meeteor.71e52e80.png";